<app-side-menu>
  <div class="warehouses-content">
    <!-- Filtros -->
    <div class="filters-section mb-4">
      <div class="filters-row">
        <div class="filter-group">
          <label for="statusFilter" class="form-label">Status</label>
          <select id="statusFilter" class="form-select" [(ngModel)]="selectedStatus" (change)="onStatusFilterChange(selectedStatus)">
            <option value="">Todos</option>
            <option *ngFor="let status of statusOptions" [value]="status.name">{{ status.name }}</option>
          </select>
        </div>

        <div class="filter-group">
          <label for="typeFilter" class="form-label">Tipo</label>
          <select id="typeFilter" class="form-select" [(ngModel)]="selectedType" (change)="onTypeFilterChange(selectedType)">
            <option value="">Todos</option>
            <option *ngFor="let t of typeOptions" [value]="t">{{ t }}</option>
          </select>
        </div>

        <div class="filter-actions">
          <button type="button" class="btn btn-outline-secondary" (click)="clearFilters()">
            <i class="fas fa-times me-2"></i>
            Limpar Filtros
          </button>
        </div>
      </div>
    </div>
    <app-table
      [title]="tableTitle"
      [columns]="columns"
      [data]="filteredWarehouses"
      [loading]="isLoading"
      [showSearch]="showSearch"
      [searchPlaceholder]="searchPlaceholder"
      [clickable]="clickable"
      [actions]="actions"
      [enableSorting]="true"
      (sortChange)="onSortChange($event)"
      (searchChange)="onSearch($event)"
      (rowClick)="edit($event)"
      (actionClick)="onActionClick($event)">
      <app-button
        *appHasPermission="'Warehouses.Manage'"
        table-header-action
        text="Novo Almoxarifado"
        [color]="'var(--primary-light)'"
        [height]="'42px'"
        className="new-warehouse-btn"
        (buttonClick)="newWarehouse()">
      </app-button>
    </app-table>
  </div>
</app-side-menu>
